export default "__VITE_ASSET__a829e751__"